/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_TitleInputs */

const cs_settings_venues_title = /** @type {(inputs: Settings_Venues_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky`)
};

const en_settings_venues_title = /** @type {(inputs: Settings_Venues_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offices`)
};

/**
* | output |
* | --- |
* | "Offices" |
*
* @param {Settings_Venues_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_title = /** @type {((inputs?: Settings_Venues_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_title(inputs)
	return cs_settings_venues_title(inputs)
});